var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKabelNetzgebietspruefung(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 244,
    viewBox: "0 0 311 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.196 3.14893L307.778 32.0013L178.556 106.879L218.397 131.656L128.506 182.96L81.6716 156.022L2.5791 206.867L62.1156 240.764",
    stroke: "#b4005f",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKabelNetzgebietspruefung);
export default __webpack_public_path__ + "static/media/Kabel-Netzgebietspruefung.9514e7be7115f193232539d1e2c86b05.svg";
export { ForwardRef as ReactComponent };